export const CompanyAppointMentEmpty = () => import('./CompanyAppointMentEmpty.vue');
export const CompanyWiseUsers = () => import('./CompanyWiseUsers.vue');
export const CompanyChildrenUserDetails = () => import('./CompanyChildrenUserDetails.vue');
export const CompanyApptUsers = () => import('./CompanyApptUsers.vue');
